module.exports = __webpack_public_path__ + "static/img_2202-0703b06810ac8d7f3c2981f9beb4a361.webp";